import ApiService from './api.service.js'

const CompanyService = {
  getCompanies() {
    return ApiService.get('companies')
  },
  getCompanyTypes() {
    return ApiService.get('company_types')
  },
  getCompany(id) {
    return ApiService.get('companies', id)
  },
  updateCompany(id, payload) {
    return ApiService.update('companies', id, payload)
  },
  deleteCompany(id, payload) {
    return ApiService.delete(`companies/${id}/`)
  },
  getBranches() {
    return ApiService.get('branches')
  },
  getBranch(id) {
    return ApiService.get('branches', id)
  },
  createBranch(payload) {
    return ApiService.post('branches', payload)
  },
  updateBranch(id, payload) {
    return ApiService.update('branches', id, payload)
  },
  createBranchCard(id, payload) {
    return ApiService.post_extra_route('branches', id, payload, 'card')
  },
  updateBranchCard(id, payload) {
    return ApiService.update_extra_route('branches', id, payload, 'card')
  },
  createBranchBankAccount(id, payload) {
    return ApiService.post_extra_route('branches', id, payload, 'bank_account')
  },
  updateBranchBankAccount(id, payload) {
    return ApiService.update_extra_route('branches', id, payload, 'bank_account')
  },
  deleteBranch(id) {
    return ApiService.delete(`branches/${id}/`)
  },
  getBranchEmployees(id) {
    return ApiService.get('branches', id, 'employees')
  },
  detachEmployee(id) {
    return ApiService.delete(`employees/${id}/branch/`)
  },
  getTranscations(payload) {
    return ApiService.query('transactions/', {
      params: payload
    })
  }

}
export default CompanyService
